<template>
  <div class="register absolute">
    <div class="register_tit">
      <img @click="$router.go(-1)" src="../../assets/images/licai/fanhui.png" />
      <p class="">{{ $t("m.rg_span3") }}</p>
    </div>
    <div class="register_block">
      <div
        style="
          background: #fff;
          border-radius: 8px;
          height: 400px;
          padding-top: 80px;
          position: relative;
          text-align: center;
        "
      >
        <img
          style="width: 60px; height: 60px"
          src="../../assets/images/licai/chengcheng.png"
          alt=""
        />
        <p style="font-size: 17px; margin: 10px 0">{{ $t("m.rg_span4") }}</p>
        <p style="font-size: 14px; color: #666">{{ $t("m.rg_span5") }}</p>
        <div
          style="
            position: absolute;
            display: flex;
            align-items: center;
            height: 60px;
            justify-content: space-between;
            left: 10px;
            right: 10px;
            bottom: 0;
            padding: 0 0px;
            color: #000;
            font-size: 15px;
            border-top: 1px solid #eee;
          "
        >
          <span>{{ dicdata.name }}</span>
          <span>{{ dicdata.money }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@utils/request";

export default {
  name: "GoodsPay",
  data: function () {
    return {
      money: "",
      mima: "",
      dicdata: {},
    };
  },

  mounted: function () {
    this.dicdata = JSON.parse(localStorage.getItem("shu"));
  },
  methods: {
    registerReset(e) {},
  },
};
</script>
<style scoped>
.register_submit {
  width: 92%;
  margin: 80px auto 0 auto;

  height: 50px;
  background: #CDA569;
  border-radius: 5px;
  margin-top: 80px !important;
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  font-size: 16px;
}
.register_block {
  padding: 10px;
}
.register_block_list {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  background: #f1f1f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 15px;
}
.register_code_lists {
  border: 1px solid #CDA569;
  text-align: center;
  color: #CDA569;
  border-radius: 6px;
  width: 36%;
  height: 45px;
  margin-left: 15px;
  line-height: 45px;
}
.register_code_list {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  background: #f1f1f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.register_code {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.register_tit {
  background: #fff;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}
/* 清除浮动*/
.am-fl {
  float: left;
}
.am-fr {
  float: right;
}
.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.am-cf {
  zoom: 1;
}
</style>
